{
    "META_TITLE": "{realEstateGroup} reviews | Score: {score}/10 - HouseMatch verified reviews",
    "META_DESCRIPTION": "Find the best realtor for you based on the largest amount of verified reviews in Belgium.",
    "META_TITLE_REVIEW": "{score}/10 for {realEstateGroup}. See all reviews!"
}